export enum DeliveryTypeEnum {
  WITHDRAWAL_POINT = 'withdrawal-point',
  STANDARD = 'standard',
  EXPRESS = 'express'
}
